import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Popconfirm, Switch } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useBoolean, useUpdateOrganization } from '@hooks';
export const PackageTagSwitch = ({ disabled, organizationId, packageTagEnabled }) => {
    const [sentPackageTagPatchRequest, setSentPackageTagPatchRequest] = useState(false);
    const [open, setOpen] = useBoolean(false);
    const { isErrored, isFailed, request, reset } = useUpdateOrganization();
    useEffect(() => {
        if (sentPackageTagPatchRequest && (isErrored || isFailed)) {
            setSentPackageTagPatchRequest(false);
            reset();
        }
    }, [isErrored, isFailed, reset, sentPackageTagPatchRequest]);
    const sendRequest = useCallback(() => {
        setSentPackageTagPatchRequest(true);
        request({
            organizationId,
            packageTagEnabled: !packageTagEnabled
        });
        setOpen.off();
    }, [organizationId, packageTagEnabled, request, setOpen]);
    const handleToggleClick = useCallback(() => {
        if (packageTagEnabled) {
            setOpen.on();
        }
        else {
            sendRequest();
        }
    }, [packageTagEnabled, sendRequest, setOpen]);
    return (React.createElement(Popconfirm, { cancelText: COPY_SPECIFIC.NO, okText: COPY_SPECIFIC.YES, onCancel: setOpen.off, onConfirm: sendRequest, open: open, title: COPY_SPECIFIC.ARE_YOU_SURE_REMOVE_PACKAGE_TAGGING },
        React.createElement(Switch, { checked: packageTagEnabled, disabled: disabled, onClick: handleToggleClick })));
};
